/**
 * App-wide constants.
 * Intentionally tiny — only the values the whole app needs to reference.
 */

// Cloudflare Worker base URL — same one the current q2-goals.html uses.
// Both dashboards read/write the same KV store, so data stays in sync
// throughout the migration.
export const API_BASE = 'https://ct-hubspot-proxy.secure-accounts-468.workers.dev'

// localStorage key used by the current dashboard — we read this as a
// fallback if the worker is unreachable.
export const LEGACY_STORAGE_KEY = 'ct-goals-q2-2026-v14'
